import $ from 'jquery';
import View from 'cdna/core/view';
import markup from './videoView.html';

export default View.extend({
    el: markup,
    bindings: {
        'GroupTitle [data-bind=group-title]': 'text',
        'Name [data-bind=title]': 'text',
        'Description [data-bind=description]': 'text'
    },
    render() {
        if (!this.model || !this.model.id) return this;

        var videoUrl = '//player.vimeo.com/video/' + this.model.id;
        this.$('iframe').remove();

        $('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
            .attr('src', videoUrl)
            .attr('frameborder', '0')
            .attr('width', this.options.width)
            .attr('height', this.options.height)
            .appendTo(this.$el);

        return this;
    }
});


/** WEBPACK FOOTER **
 ** ./client/video/videoView.js
 **/